import React, { Component } from 'react';
import { connect } from 'react-redux';
import R from 'ramda';
import {
  Avatar,
  CircularProgress,
  RaisedButton,
} from 'material-ui';
import moment from 'moment';
import UploadBox from './upload-box';
import OptInSuccess from './opt-in-success';
import OptOutSuccess from './opt-out-success';
import injectSheet from 'react-jss';
import LoadingOverlay from '../../tc-ui/loading-overlay';
import{
  openDialog,
} from '../__storeFiles__/actions';

class Request extends Component {
  constructor() {
    super();
    this.state = {
      filesUploaded: [],
      message: '',
      showMsgBoxForSendingUpdates: false,
    };
  }
  onMessageChange = ({ target: { value } }) => this.setState({ message: value });
  addFiles = files => this.setState({ filesUploaded: [...this.state.filesUploaded, ...files] });
  removeFile = index => () => this.setState({ filesUploaded: R.remove(index, 1, this.state.filesUploaded) });
  sendRates = () => this.props.sendRates({
    files: this.state.filesUploaded,
    message: this.state.message,
    requests: [{ _id: this.props.contractId }],
  });
  openSignUp = () => this.props.openDialog({
    type: 'signup',
    viewAs: 'Supplier',
    country: this.props.country,
    signupEmail: this.props.email,
    companyName: this.props.to.name || this.props.email,
    preconfirmed: true,
  });
  needToSendUpdate = () => this.setState({ showMsgBoxForSendingUpdates: true });
  render() {
    const {
      deadlineDate,
      sendingRates,
      ratesSent,
      rateConversionSetting,
      files,
    } = this.props;
    const {
      filesUploaded,
      message,
      showMsgBoxForSendingUpdates,
    } = this.state;
    return (
      <div>
        {
          (() => {
            if (ratesSent) {
              if (rateConversionSetting === 'opt-in') {
                return <OptInSuccess/>;
              }
              return <OptOutSuccess openSignUp={this.openSignUp}/>;
            }
            if (files && files.length && !showMsgBoxForSendingUpdates) {
              return (
                <div style={{ margin: '2em', textAlign: 'center' }}>
                  <div style={{ marginBottom: '2em' }}>
                    Thank you, we’ve received your rates for this contract request.
                  </div>
                  <RaisedButton
                    label="NEED TO SEND UPDATES?"
                    secondary
                    onClick={this.needToSendUpdate}
                  />
                </div>
              );
            }
            return (
              <div>
                <div style={{ marginTop: '1.5em', color: 'rgba(0, 0, 0, 0.77)' }}>
                  {
                    files && files.length
                      ? 'Thank you, we’ve received your rates for this contract request.'
                      : `Please upload your rates by ${moment.utc(new Date(deadlineDate)).format('DD MMM YYYY')}, so that we can book your products.`
                  }
                </div>
                <UploadBox
                  message={message}
                  onMessageChange={this.onMessageChange}
                  addFiles={this.addFiles}
                  filesUploaded={filesUploaded}
                  deadlineDate={deadlineDate}
                  removeFile={this.removeFile}
                  sendRates={this.sendRates}
                  btnLabel={files && files.length ? 'Send Updates' : 'Send Rates'}
                />
              </div>
            );
          })()
        }
        <LoadingOverlay
          loading={sendingRates}
        />
      </div>
    );
  }
}

const mapState = ({ assetsLandingReducer }) => ({
  ...assetsLandingReducer.request,
  loading: assetsLandingReducer.requestLoading,
  country: assetsLandingReducer.country,
  email: assetsLandingReducer.email,
});

const styles = {
  container: {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '2em',
    height: '100%',
    color: 'rgba(0, 0, 0, 0.87)',
  },
  footer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    margin: '4em auto',
  },
  powerby: {
    display: 'flex',
    alignItems: 'center',
  },
  footerText: {
    margin: '8px auto',
  },
  terms: {
    fontSize: '12px',
    color: 'rgba(0, 0, 0, 0.54)',
    textDecoration: 'underline',
  },
};

const mapAction = ({
  sendRates: payload => ({ type: '[asset-landing]SEND_RATES_FOR_ONE_REQUEST', payload }),
  openDialog,
});

export default connect(mapState, mapAction)(injectSheet(styles)(Request));



// WEBPACK FOOTER //
// ./src/app/components/assets-landing/request/request.jsx